export const testId = {
    addSurvey: "add-survey",
    copyBtn: "copy-btn",
    dictionarySlot: "dictionary-slot",
    increasedSlotInput: "increased-slot-input",
    saveSurveyField: "save-survey-field",
    slotInput: "slot-input",
    surveyFieldActionButton: "survey-field-action-button"
} as const
